import React, { ComponentType } from 'react';

import Spinner from '@/src/components/common/Elements/Spinner/Spinner';
import { useConnectedApps } from '@/src/components/project/Inbox2/components/EntryPanel/FileEntryViewer/components/InfoPanel/Treatment/api/getConnectedApps';

import { APP_LIST } from '../Config';

export type AppConfigType = {
  id: string;
  name: string;
  shortName: string;
  css: {
    image: string;
  };
  Card: ComponentType<any>;
};
export const AppList = ({ projectId }: { projectId: string }) => {
  const connectedAppsQuery = useConnectedApps({
    projectId,
    config: {
      cacheTime: 0,
    },
  });

  if (connectedAppsQuery.isLoading) {
    return <Spinner />;
  }

  return (
    <div className="app-settings-container">
      {APP_LIST.map((appConfig) => {
        const app = connectedAppsQuery.data ? connectedAppsQuery.data[appConfig.id] : null;

        return (
          <appConfig.Card
            key={appConfig.id}
            appConfig={appConfig}
            app={app}
            projectId={projectId}
            onDisconnect={connectedAppsQuery.refetch}
            onRefresh={connectedAppsQuery.refetch}
          />
        );
      })}
    </div>
  );
};
